module.exports = __webpack_public_path__ + "img/img2.ed373872.jpg";